import Dispatcher from '../dispatcher';
import {actions} from '../constants/address/shipping_address_actions';

export function setStreetAction(street) {
    Dispatcher.handleShippingAddressAction({
        type: actions.SET_STREET,
        payload: street
    });
}

export function setStreetNumberAction(streetNumber) {
    Dispatcher.handleShippingAddressAction({
        type: actions.SET_STREET_NUMBER,
        payload: streetNumber
    });
}

export function setSuburbAction(suburb) {
    Dispatcher.handleShippingAddressAction({
        type: actions.SET_SUBURB,
        payload: suburb
    });
}

export function setCityAction(city) {
    Dispatcher.handleShippingAddressAction({
        type: actions.SET_CITY,
        payload: city
    });
}

export function setStateAction(state) {
    Dispatcher.handleShippingAddressAction({
        type: actions.SET_STATE,
        payload: state
    });
}

export function setFirstNameAction(firstName) {
    Dispatcher.handleShippingAddressAction({
        type: actions.SET_FIRST_NAME,
        payload: firstName
    });
}

export function setLastNameAction(lastName) {
    Dispatcher.handleShippingAddressAction({
        type: actions.SET_LAST_NAME,
        payload: lastName
    });
}

export function setCountryAction(country) {
    Dispatcher.handleShippingAddressAction({
        type: actions.SET_COUNTRY,
        payload: country
    });
}

export function setEmailAction(email) {
    Dispatcher.handleShippingAddressAction({
        type: actions.SET_EMAIL,
        payload: email
    });
}

export function setTelephoneAction(telephone) {
    Dispatcher.handleShippingAddressAction({
        type: actions.SET_TELEPHONE,
        payload: telephone
    });
}

export function setPostcodeAction(postcode) {
    Dispatcher.handleShippingAddressAction({
        type: actions.SET_POSTCODE,
        payload: postcode
    });
}

export function setAddressType(addressType) {
    Dispatcher.handleShippingAddressAction({
        type: actions.SET_ADDRESS_TYPE,
        payload: addressType
    });
}

export function setInvalid(payload) {
    Dispatcher.handleShippingAddressAction({
        type: actions.SET_INVALID,
        payload: payload
    });
}

export function unsetInvalid(payload) {
    Dispatcher.handleShippingAddressAction({
        type: actions.UNSET_INVALID,
        payload: payload
    });
}

export function resetInvalid() {
    Dispatcher.handleShippingAddressAction({
        type: actions.RESET_INVALID,
    });
}

export function setAutoSuggestResult(payload) {
    Dispatcher.handleShippingAddressAction({
        type: actions.SET_AUTOSUGGEST_RESULT,
        payload: payload
    });
}

export function clearAutoSuggestResult() {
    Dispatcher.handleShippingAddressAction({
        type: actions.CLEAR_AUTOSUGGEST_RESULT,
    });
}
